'use client';

import { extractUtmParamsFromUrl } from '@benzinga/analytics';
import type { SessionContextType } from '@benzinga/session-context';
import { TrackingManager } from '@benzinga/tracking-manager';
import type { AdPartner } from '@benzinga/ads-utils';

export interface TrackAdImpressionParams {
  destinationUrl: string | null;
  partnerId: AdPartner;
  session: SessionContextType;
  unitType: string;
}

export function trackAdImpression({ destinationUrl, partnerId, session, unitType }: TrackAdImpressionParams): void {
  const utmParams: Record<string, string> = {};

  if (destinationUrl) {
    Object.assign(utmParams, extractUtmParamsFromUrl(destinationUrl));
  }

  const campaignId = utmParams.campaign || '';

  session.getManager(TrackingManager).trackCampaignEvent('view', {
    campaign_id: campaignId,
    destination_url: destinationUrl || undefined,
    non_interaction: true,
    partner_id: partnerId,
    unit_type: unitType,
    utmParams,
  });
}
